var map = {
	"./app_gyver.svg": "3RtT",
	"./blok.svg": "vbz4",
	"./bonsky_digital.svg": "R52J",
	"./bubblin.svg": "h/k6",
	"./cinia.svg": "HcMi",
	"./circles.svg": "198t",
	"./codento.svg": "6QPu",
	"./compile.svg": "SoB4",
	"./eficode.svg": "GofF",
	"./elisa.svg": "FOkN",
	"./emblica.svg": "MG3U",
	"./futurice.svg": "rc7y",
	"./g_works.svg": "4jT8",
	"./geometrix.svg": "0Yh9",
	"./gofore.svg": "cP6v",
	"./hiq.svg": "wtsH",
	"./houston.svg": "98iT",
	"./houston2.svg": "mZVF",
	"./ilmatieteenlaitos.svg": "iv/R",
	"./integrify.svg": "ZeDQ",
	"./kela.svg": "Fmie",
	"./kesko.svg": "pWwX",
	"./kodan.svg": "WSZS",
	"./konecranes.svg": "vf9u",
	"./motley.svg": "GwXG",
	"./neemia.svg": "j7GV",
	"./netyourself.svg": "TAJx",
	"./nextup.svg": "irX6",
	"./nordcloud.svg": "P5/b",
	"./nortal_oy.svg": "usXl",
	"./nurse_buddy.svg": "ltN3",
	"./omnia.svg": "JdcT",
	"./perfektio.svg": "oCIo",
	"./plan_brothers.svg": "T0Q2",
	"./platonic_partnership.svg": "GrMt",
	"./pori.svg": "YoUk",
	"./relex.svg": "b17o",
	"./rentle.svg": "U/i3",
	"./resilient_e.svg": "yAPE",
	"./siili.svg": "7W+i",
	"./smartly_io.svg": "B5K9",
	"./sympa.svg": "vcdg",
	"./tabella.svg": "+fIx",
	"./taito_united.svg": "m0Xi",
	"./telia.svg": "fCc7",
	"./terveystalo.svg": "vnHe",
	"./tietotalo.svg": "Ua5r",
	"./tivia.svg": "4ezL",
	"./umbrella_interactive.svg": "4LAG",
	"./unity-scaled.svg": "QVuv",
	"./unity.svg": "rwfy",
	"./uoh_centre.svg": "0Yyr",
	"./uoh_left-align.svg": "uclQ",
	"./up_cloud.svg": "uoQp",
	"./vero.svg": "IjjB",
	"./vincit.svg": "LxhF",
	"./visma.svg": "XOPh",
	"./webscale.svg": "0GAh",
	"./wolt.svg": "zhfB",
	"./wunderdog.svg": "iXs1",
	"./zaibatsu.svg": "htzA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IxoE";